import { lazy, ComponentType } from 'react';

/**
 * Enhanced lazy loading with automatic retry on chunk load failure
 * This prevents "Failed to fetch dynamically imported module" errors
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  retries = 3,
  interval = 1000
): React.LazyExoticComponent<T> {
  return lazy(async () => {
    for (let i = 0; i < retries; i++) {
      try {
        return await importFunc();
      } catch (error) {
        const isChunkError = error instanceof Error && 
          (error.message.includes('Failed to fetch dynamically imported module') ||
           error.message.includes('Importing a module script failed') ||
           error.message.includes('Failed to load module script'));
        
        if (isChunkError && i < retries - 1) {
          console.log(`[CHUNK_RETRY] Chunk load failed, retry ${i + 1}/${retries}...`);
          await new Promise(resolve => setTimeout(resolve, interval));
          continue;
        }
        throw error;
      }
    }
    throw new Error('Max retries reached for chunk loading');
  });
}
